import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  informationContainerWrapper: {
    paddingBottom: '1.5vh',
  },
  informationContainer: {
    borderBottom: `1px solid ${themeColor.borderGray}`,
    justifyContent: 'flex-end',
    paddingBottom: '0.5vh',
  },
  configurationMenuContainer: {
    paddingTop: '3.51vh',
    paddingLeft: '1.46vw',
    paddingRight: '1.46vw',
    '& > div': {
      paddingBottom: '2.86vh',
      zIndex: 1,
    },
  },
  loginOptionHeading: {
    fontSize: rem(1),
    fontWeight: 500,
    lineHeight: 1.11,
    letterSpacing: 0.17,
    color: themeColor.defaultTextColor,
    paddingBottom: '0.78vh',
  },
  loginOptionSubHeading: {
    fontSize: rem(0.875),
    fontWeight: 400,
    lineHeight: 0.987,
    letterSpacing: 0.17,
    color: themeColor.subheaderLight,
    paddingBottom: '0.78vh',
  },
  loginMenuButton: {
    display: 'block',
    textTransform: 'none',
    textAlign: 'left',
    padding: 0,
    width: '100%',
  },
  deviceAlertIcon: {
    fill: themeColor.alert,
  },
  loginMenuDisabledItem: {
    opacity: 0.4,
  },
}));
